import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Artifact} from "@webmate-web-core/shared/types/artifact";

@Component({
    selector: 'wm-mailcontent-artifact',
    templateUrl: './mailcontent-artifact.component.html',
    styleUrls: ['./mailcontent-artifact.component.less']
})
export class MailContentArtifactComponent implements OnInit {

    @Input() artifact: Artifact;

    initialIndex = 0;

    @ViewChild("htmlmail") htmlMailElem: ElementRef;

    constructor(private cdRef: ChangeDetectorRef) {}

    ngOnInit() {

        // setTimeout(() => {
            this.initialIndex = !!this.artifact?.data['emailContent']['htmlBody'] ? 0 : 1;
        // }, 0)
        // this.cdRef.markForCheck();
    }

}
